module.exports = __webpack_public_path__ + "img/intestine.cc333e9a.png";